import {ReactElement} from 'react';
import {deleteRecord} from 'core/LifeCycle';
import {isEmpty} from 'core/History';
import {useCoreState} from 'store/utils';
import {toggleHistory, useUIStore} from 'store/UI';
import {useStateDependentAdapters} from 'ui/adapters';
import {useDispatch} from 'ui/store';

export interface DeleteRecordProps {
  deleteRecord: (record: RecordEntry) => void;
}

export function useDeleteRecord(): (record: RecordEntry) => void {
  const callAdapters = useStateDependentAdapters();
  const closeHistory = useDispatch(toggleHistory);
  const coreState = useCoreState();
  const uiStore = useUIStore();

  return function performDeletion(record: RecordEntry): void {
    const {historyVisible} = uiStore;
    const newSettings = deleteRecord(coreState, record);
    const shouldCloseHistory = isEmpty(newSettings.history) && historyVisible;

    if (shouldCloseHistory) closeHistory();
    callAdapters(newSettings);
  };
}

interface Props {
  children: (settings: DeleteRecordProps) => ReactElement;
}

export function DeleteRecord({children}: Props): ReactElement {
  const handleDeletion = useDeleteRecord();
  return children({deleteRecord: handleDeletion});
}
